<div class="summary-order-title-container">
    <h1 *ngIf="!patient" [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{ 'shared.medicalOrder.summary.text1' | translate:locale.language:{ tipoSolicitud: (title | translate:locale.language) } }}
    </h1>
    <h1 *ngIf="patient" [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{ 'shared.medicalOrder.summary.text2' | translate:locale.language:{patientName: patient, tipoSolicitud: (title | translate:locale.language)} }}
    </h1>
</div>